<div class="loader-container"><div class="loader-block"><div class="loader"></div></div></div>